import { render, staticRenderFns } from "./CmgUnsupportedBrowserHeader.vue?vue&type=template&id=068dbdb4&scoped=true&lang=pug"
import script from "./cmg-unsupported-browser-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-unsupported-browser-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgUnsupportedBrowserHeader.vue?vue&type=style&index=0&id=068dbdb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068dbdb4",
  null
  
)

export default component.exports